export default "__VITE_ASSET__BOldpEZX__"